<div class="EFProductCard card {{ vertical ? 'EFProductCard--Vertical mb-3': '' }} {{ fill ? 'EFProductCard--Fill': '' }} {{ disabled ? 'EFProductCard--Disabled': '' }}"
    [attr.role]="disabled ? null : 'button'"
    [attr.tabindex]="disabled ? null : 0"
    [attr.aria-disabled]="disabled || null"
    [attr.aria-label]="getCardAriaLabel()"
    (click)="onCardClick()"
    (keydown)="onCardKeydown($event)">
    @if (productData && productData.error) {
        <div class="card-body text-center">
            <div class="alert alert-danger" role="alert">
                <div class="mb-3">
                    <i class="fa-regular fa-exclamation-triangle fa-3x" aria-hidden="true"></i>
                </div>
                <div>
                    {{ 'experience-finder.general.product-error' | locTranslate }}
                </div>
            </div>
        </div>
    }
    @if (productData && !productData.error) {
        <div class="EFProductCard-Image">
            <div class="card-img-top">
                @if (getCoverImage(); as image) {
                    <div>
                        <app-pg-image-autosize [src]="image" fit="cover" [alt]="'experience-finder.a11y.product-image' | locTranslate:'title':(productData.getTranslatedProductField('title') | stripHTML)"></app-pg-image-autosize>
                    </div>
                }
            </div>

            @if(productData.tagImages.length > 0) {
                <div class="EFProductCard-Image-TagImages" aria-hidden="true">
                    @for(tagImage of productData.tagImages; track tagImage) {
                        <app-pg-tag-image [tag]="tagImage.tag" [image]="tagImage.image" [color]="getTypeColor(productData.type)"></app-pg-tag-image>
                    }
                </div>
            }
            @if (productData.isPastProduct()) {
                <div class="EFProductCard-Image-PastProduct badge text-white bg-secondary">
                    <i class="fa-regular fa-hourglass-end" aria-hidden="true"></i>
                    <span class="ms-2">{{ 'experience-finder.general.past-' + productData.type | locTranslate }}</span>
                </div>
            }
        </div>
        <div class="EFProductCard-Content {{ getCoverImage() ? 'EFProductCard-Content--HasImage' : '' }}">
            <div class="card-body">
                <div class="EFProductCard-Info EFProductCard-Info--Header">
                    <div>
                        @if (getProductDuration(); as text) {
                            <span class="me-3">
                                <i class="fa-regular fa-stopwatch" aria-hidden="true"></i>
                                <small class="ms-2">{{text}}</small>
                            </span>
                        }
                        @if (productData.travel_stops; as stops) {
                            <span class="me-3">
                                <i class="fa-regular fa-route" aria-hidden="true"></i>
                                <small class="ms-2">{{stops}}</small>
                            </span>
                        }
                        @if (productData.stars; as stars) {
                            <span class="me-3" [attr.aria-label]="'experience-finder.app.product-stars' | locTranslate">
                                <small aria-hidden="true">
                                    @for (i of [1,2,3,4,5]; track i) {
                                        @if (i <= stars) {
                                            <i class="fa-solid fa-star text-warning opacity-100"></i>
                                        }
                                        @if (i > stars) {
                                            <i class="fa-regular fa-star text-muted opacity-50"></i>
                                        }
                                    }
                                </small>
                                <span class="visually-hidden">{{stars}}/5</span>
                            </span>
                        }
                    </div>
                    <div class="d-flex">
                        @if (productData.purchased) {
                            <span class="badge bg-success me-2">{{ 'experience-finder.general.purchased' | locTranslate }}</span>
                        }
                        @if (getCostDisplay(); as cost) {
                            <small [innerHTML]="cost"></small>
                        }
                    </div>
                </div>
                <div class="EFProductCard-Content-Inner mb-2">
                    <h3 class="card-title h5 m-0">
                        @if (!productData.published) {
                            <div class="float-end">
                                <i class="fa-regular fa-eye-slash" aria-hidden="true"></i>
                            </div>
                        }
                        <span [innerHTML]="productData.getTranslatedProductField('title')"></span>
                    </h3>
                    @if (productData.getTranslatedProductField('description'); as description) {
                        <div class="card-text text-muted mt-2" [innerHTML]="description | safe:'html'"></div>
                    }
                </div>
                @if (productData.link; as link) {
                    <div class="EFProductCard-Info EFProductCard-Info--Link mt-3">
                        <button type="button" class="btn btn-block btn-{{ link.color || 'primary' }}" (click)="onLinkButtonClick($event)">
                            @if (link.icon) {
                                <i class="{{link.icon}}" aria-hidden="true"></i>
                            }<span>{{link.text}}</span>
                        </button>
                    </div>
                }
                <div class="EFProductCard-Info EFProductCard-Info--Header">
                    <div>
                        @if (productData.getDateDisplay(); as date) {
                            <span>
                                <i class="fa-regular fa-calendar" aria-hidden="true"></i>
                                <small class="ms-1">{{date}}</small>
                            </span>
                        }
                    </div>
                    <div>
                        @if (productData.mean_of_transport; as transport) {
                            <small class="EFProductCard-Info-MeanOfTransport" aria-hidden="true">
                                @for (item of transport; track item) {
                                    @if (item == 'walking') {
                                        <i class="ms-1 fa-regular fa-lg fa-walking"></i>
                                    }
                                    @if (item == 'bicycling') {
                                        <i class="ms-1 fa-regular fa-lg fa-biking"></i>
                                    }
                                    @if (item == 'driving') {
                                        <i class="ms-1 fa-regular fa-lg fa-car"></i>
                                    }
                                    @if (item == 'motorcycle') {
                                        <i class="ms-1 fa-regular fa-motorcycle"></i>
                                    }
                                    @if (item == 'public_transport') {
                                        <i class="ms-1 fa-regular fa-bus"></i>
                                    }
                                }
                            </small>
                        }
                    </div>
                </div>
                <div class="EFProductCard-Info EFProductCard-Info--Footer">
                    <span>
                        @if (productData.type != 'custom') {
                            <span class="badge text-white" [style.backgroundColor]="getTypeColor(productData.type)">
                                <i class="fa-regular" [innerHTML]="getTypeIcon(productData.type)" aria-hidden="true"></i>
                                <span class="ms-2">{{productData.getTypeText()}}</span>
                            </span>
                        }
                    </span>
                    @if (productData.getCategoryText(); as text) {
                        <span class="badge bg-white border ms-2" [style.color]="getTypeColor(productData.type)" [style.borderColor]="getTypeColor(productData.type) + ' !important'">
                            <span [innerHTML]="text"></span>
                        </span>
                    }
                </div>
            </div>
        </div>
    }
</div>
